import { render, staticRenderFns } from "./ChangeTextToQuestions.vue?vue&type=template&id=43c4b955"
import script from "./ChangeTextToQuestions.vue?vue&type=script&lang=js"
export * from "./ChangeTextToQuestions.vue?vue&type=script&lang=js"
import style0 from "./ChangeTextToQuestions.vue?vue&type=style&index=0&id=43c4b955&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c4b955')) {
      api.createRecord('43c4b955', component.options)
    } else {
      api.reload('43c4b955', component.options)
    }
    module.hot.accept("./ChangeTextToQuestions.vue?vue&type=template&id=43c4b955", function () {
      api.rerender('43c4b955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeTextToQuestions.vue"
export default component.exports